import { useEffect, useState } from "react";
import api from "@/lib/api";
import BeatCard from "@/components/BeatCard";

export default function Feed() {
  const [beats, setBeats] = useState([]);
  const [sort, setSort] = useState("new");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/beats?sort=${sort}`);
      setBeats(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, [sort]);

  const onBeatChange = (updated) => {
    setBeats((prev) => prev.map((b) => (b.id === updated.id ? updated : b)));
  };

  return (
    <div data-testid="feed-page" className="px-6 md:px-12 py-12 max-w-7xl mx-auto">
      <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
        <div>
          <div className="font-mono-acc text-xs text-secondary">// COMMUNITY FEED</div>
          <h1 className="font-display text-5xl md:text-6xl mt-3">The <span className="text-primary">beats</span>.</h1>
        </div>
        <div className="flex gap-2">
          {[
            { k: "new", l: "Newest" },
            { k: "top", l: "Most Voted" },
          ].map((opt) => (
            <button
              key={opt.k}
              data-testid={`sort-${opt.k}`}
              onClick={() => setSort(opt.k)}
              className={`font-mono-acc text-xs px-4 py-2 border ${
                sort === opt.k ? "border-primary bg-primary text-white" : "border-border hover:border-foreground"
              }`}
            >
              {opt.l}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <p data-testid="feed-loading" className="font-mono-acc text-sm text-muted-foreground">
          <span className="rec-dot mr-2" /> Loading beats...
        </p>
      ) : beats.length === 0 ? (
        <div data-testid="feed-empty" className="border border-border p-12 text-center">
          <p className="font-display text-3xl mb-3">No beats yet.</p>
          <p className="text-muted-foreground">Be the first to drop one.</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {beats.map((b) => (
            <BeatCard key={b.id} beat={b} onChange={onBeatChange} showCoverGen />
          ))}
        </div>
      )}
    </div>
  );
}
